/* @flow */

import { useDispatch, useSelector, useStore } from 'react-redux';
import React, { useContext, useState } from 'react';

import type { TCity } from '../../types/city';

import { fetchNewsData, fetchSearchNewsData } from '../../actions/news';

// import PopupQuestion from '../../components/PopupQuestion';
import Breadcrumbs from '../../components/Breadcrumbs';
import Button from '../../components/Button2.0';
import Preloader from '../../components/Preloader';
import TilesArticles from '../../components/TilesArticles';

import { AppContext } from '../../components/AppContext';
import { generateBreadcrumbs } from '../../utils/breadcrumbs';
import {
	ExtraButtonWrapper,
	Header,
	List,
	NotFound,
	Root,
	SearchPanel,
	SearchWrapper,
	Title,
} from '../knowledge/styles';
import { Container } from '../../components/Layout/styles';
import type { TDispatch } from '../../types/core';
import type { TNews } from '../../reducers/news';
import type { TRootState } from '../../types/rootState';
import notFound from '../../../public/images/errors/not-found.png';
import notFound2x from '../../../public/images/errors/not-found@2x.png';
import notFound3x from '../../../public/images/errors/not-found@3x.png';

const searchData = {
	type: 'text',
	placeholder: 'Поиск по разделу',
};

const News = () => {
	const dispatch: TDispatch = useDispatch();
	const store = useStore();
	const context = useContext(AppContext);
	const news: TNews = useSelector((state: TRootState) => state.news);
	const city: TCity = useSelector((state: TRootState) => state.city);

	const [searchString, setSearchString] = useState('');

	const { articles, pageCount, currentPage, isLoading, isLoaded } = news;

	const isLast = currentPage === pageCount - 1;

	const breadCrumbsNew = generateBreadcrumbs(city.link, [
		{
			index: 3,
			title: 'Новости',
			link: `/${city.link}/news/`,
		},
	]);

	const loadMore = async () => fetchNewsData(currentPage + 1)(dispatch, store.getState, context);

	const handleChangeSearch = async (value: string) => {
		setSearchString(value);

		if (value.length > 1) {
			await fetchSearchNewsData(value)(dispatch, store.getState, context);
		} else {
			await fetchNewsData()(dispatch, store.getState, context);
		}
	};

	return (
		<Root isLast={isLast}>
			<Container>
				<Breadcrumbs data={breadCrumbsNew} />

				<Header>
					<Title>Новости недвижимости</Title>
					<SearchWrapper>
						<SearchPanel data={searchData} value={searchString} handleChangeSearch={handleChangeSearch} />
					</SearchWrapper>
				</Header>

				{articles?.length > 0 && (
					<List>
						<TilesArticles data={articles} section="news" />

						{isLoading && <Preloader />}
						{!isLast && (
							<ExtraButtonWrapper>
								<Button onClick={loadMore} size="s" color="gray" style={{ padding: '0 30px' }}>
									Показать ещё
								</Button>
							</ExtraButtonWrapper>
						)}
					</List>
				)}
				{!isLoading && isLoaded && articles?.length <= 0 && (
					<NotFound>
						<figure>
							<img src={notFound} srcSet={`${notFound2x} 2x, ${notFound3x} 3x`} alt="" />
						</figure>
						<p>Ничего не нашли</p>
					</NotFound>
				)}
			</Container>
		</Root>
	);
};

export default News;
